// Module
var code = `<div appHeaderBar><header-bar-title>Wallet</header-bar-title></div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div *ngIf="doneLoading && apiCalled && !hasPaymentMethod" class="HOA-layout-align HOA-layout-align--middle">
        <div class="HOA-container HOA-container-splash-box">
                <span class="Illustration Illustration--responsive Illustration--blue background-image-none">
                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
                        <title>HOA Wallet Landing Icon</title>
                        <path d="M161.7,161v11c0,3.9-4.4,7.1-9.8,7.1H43.6a9.8,9.8,0,0,1-9.8-9.8V94.1a9.8,9.8,0,0,1,9.8-9.8H151.9c5.4,0,9.8,2.4,9.8,5.3V99.7"
                              fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                        <path d="M171.6,147.1H107a16.9,16.9,0,0,1-16.9-16.9v-5.4A16.9,16.9,0,0,1,107,108h64.5Z"
                              fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                        <circle cx="109.8" cy="127.5" r="8.4" fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round"/>
                        <line x1="55.9" y1="100.9" x2="55.9" y2="160.5" fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round"/>
                        <line x1="36.4" y1="87.4" x2="70.2" y2="60.5" fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                        <path d="M85.8,77.6l38.6-45.4a3,3,0,0,1,4.2-.3l33.6,28.5a3.7,3.7,0,0,1,.7,4.5l-4.8,8" fill="none" stroke="#105fa8"
                              stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path d="M72.2,75.2l35.1-63a3.3,3.3,0,0,1,4.2-1.4l40,18.3a3.1,3.1,0,0,1,1.5,4l-4,9.1" fill="none"
                              stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path d="M119.1,67.9a6.6,6.6,0,0,0,2.4,4.7c2.6,2.3,6.1,2,7.9-.3s1-5.3-.7-8-2.5-5-.5-7.4,5.2-2,7.3-.2a6.4,6.4,0,0,1,2.3,4.3"
                              fill="none" stroke="#105fa8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <line x1="119.2" y1="75.9" x2="121.8" y2="72.8" fill="none" stroke="#105fa8" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="2"/>
                        <line x1="135.5" y1="56.7" x2="137.9" y2="53.9" fill="none" stroke="#105fa8" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="2"/>
                    </svg>
                </span>
            <h1 class="HOA-splash__title">My Wallet</h1>
            <div class="HOA-splash-copy--light u-mB3">
                Easily and securely make payments by adding cards and bank accounts to your wallet.
            </div>
            <!--<div class="HOA-splash-copy&#45;&#45;light">Choose a Payment Method to add to <span class="u-textNoWrap">your Wallet.</span></div>-->
            <div class="HOA-Wallet-Container-Flex">
                <button type="button" (click)="cardAdd()" class="HOA-wallet-splash-button Button Button--blue" tid="addCreditCardButton">Add Card&#x2a;</button>
                <div class="HOA-Wallet-CF-spacer"></div>
                <button type="button" (click)="checkAdd()" class="HOA-wallet-splash-button Button Button--blue" tid="addCheckingAccountButton">Add Bank Account&#x2a;</button>
            </div>
            <div class="HOA-splash-copy-details">&#x2a;Fees may apply</div>
        </div>
    </div>

    <!-- Has Account Info -->
    <div *ngIf="doneLoading && apiCalled && hasPaymentMethod">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text" tid="paymentMethodHeader">Payment Methods</div>
            </div>

            <div class="HOA-container__content">
                <!-- Card Section Label -->
                <div class="HOA-flex-component HOA-flex-component__vertical-center  HOA-flextable-component__cell--mB30">
                    <div class="HOA-flextable-component__subheader" tid="cardHeader">
                        Cards
                    </div>
                    <div class="u-pL4">
                        <button type="button" *ngIf="cardPaymentMethods.length > 0" class="HOA-link u-margin-right-align"
                                (click)="cardAdd()" tid="addCardLink">
                            Add Card
                        </button>
                    </div>
                </div>

                <div *ngIf="!cardPaymentMethods.length > 0" class="u-pB5" tid="noAcctAddCardBody">
                    <!-- No cards message -->
                    Would you like to
                    <button type="button" class="HOA-link u-margin-right-align" (click)="cardAdd()" tid="noAcctAddCardLink">
                        add a card
                    </button>?
                </div>

                <div *ngIf="cardPaymentMethods.length > 0">
                    <!-- Card Table Header -->
                    <div class="HOA-flextable-component ">
                        <div class="u-app-hide-if-size-is-phone HOA-flextable-component__cell-wallet-column1 HOA-flextable-component__cell-center HOA-flextable-component__cell-label" tid="cardTableHeaderDefault">
                            Default
                        </div>
                        <div class="HOA-flextable-component__cell-wallet-column2-header HOA-flextable-component__cell-label HOA-flextable-component__space-between" tid="cardTableHeaderCards">
                            Cards
                        </div>
                        <div class="u-app-hide-if-size-is-phone HOA-wallet-flex-table-cell__fixed HOA-flextable-component__cell-label" tid="cardTableHeaderExpDate">
                            Exp. Date
                        </div>
                        <div class="HOA-container__content-hrule HOA-flextable-component__cell--100"></div>
                    </div>

                    <!-- Card Table Rows -->
                    <div *ngFor="let card of cardPaymentMethods">
                        <div class="HOA-flex-component" >
                            <div class="HOA-flextable-component__cell-wallet-column1 HOA-flextable-component__cell-center HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value">
                            <span class="Icon Icon--18 u-iconBlue" *ngIf="card.defaultMethod" tid="defaultRadioButton" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                                    <title>Default Payment Method</title>
                                    <path class="stroke_layer fill_layer" fill="#082538" stroke="#082538" stroke-linecap="round"
                                          stroke-linejoin="round" stroke-width="4.6"
                                          d="M36.3 9l6.3 20.6h20.7L46.6 42.4 52.9 63 36.3 50.3 19.6 63l6.3-20.6L9.3 29.6h20.6L36.3 9z">
                                    </path>
                                </svg>
                            </span>
                            </div>
                            <div class="HOA-flextable-component__cell-wallet-column2 HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value HOA-flextable-component__lg-space-between">
                                <a [routerLink]="['/wallet/viewcarddetails', card.id]" [state]="{paymentMethodId: card.id}" tid="cardDetailsLink">
                                    <div class="HOA-wallet-landing-bank-name" tid="paymentMethodNickname">{{card.nickname}}
                                        <span class="HOA-wallet-landing-bank-number" tid="maskedNumber">({{card.maskedId}})</span>
                                    </div>
                                </a>
                            </div>
                            <div class="u-app-hide-if-size-is-phone HOA-wallet-flex-table-cell__fixed HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value" tid="cardExpirationDate">
                                {{card.expirationMonth}} / {{ card.expirationYear}}
                            </div>

                        </div>
                        <div class="HOA-container__content-hrule HOA-flextable-component__cell--100"></div>
                    </div>
                </div>

                <!-- Bank Acct Section Label -->
                <div class="HOA-flex-component HOA-flex-component__vertical-center HOA-flextable-component__cell--mB30 HOA-flextable-component__cell-mT25">
                    <div class="HOA-flextable-component__subheader" tid="checkingHeader">
                        Bank Accounts
                    </div>
                    <div class="u-pL4">
                        <button type="button" *ngIf="checkPaymentMethods.length > 0" (click)="checkAdd()"
                                class="HOA-link u-margin-right-align " tid="addCheckingAccountLink">
                            Add Bank Account
                        </button>
                    </div>
                </div>

                <div *ngIf="!checkPaymentMethods.length > 0" class="u-pB5" tid="noAcctCheckingBody">
                    <!-- No check account message -->
                    Would you like to
                    <button type="button" class="HOA-link u-margin-right-align" (click)="checkAdd()" tid="noAcctAddCheckLink">
                        add a bank account
                    </button>?
                </div>

                <div *ngIf="checkPaymentMethods.length > 0">
                    <!-- Bank Acct Table Header -->
                    <div class="HOA-flextable-component ">
                        <div class="u-app-hide-if-size-is-phone HOA-flextable-component__cell-wallet-column1 HOA-flextable-component__cell-center HOA-flextable-component__cell-label" tid="checkTableDefault">
                            Default
                        </div>
                        <div class="HOA-flextable-component__cell-wallet-column2-header HOA-flextable-component__cell-label HOA-flextable-component__space-between" tid="checkTableAccount">
                            Account
                        </div>
                        <div class="HOA-container__content-hrule HOA-flextable-component__cell--100"></div>
                    </div>

                    <!-- Bank Acct Table Rows -->
                    <div *ngFor="let check of checkPaymentMethods">
                        <div class="HOA-flex-component">
                            <div class="HOA-flextable-component__cell-wallet-column1 HOA-flextable-component__cell-center HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value">
                            <span class="Icon Icon--18 u-iconBlue" *ngIf="check.defaultMethod" tid="checkingDefaultRadioButton">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 72 72">
                                    <title>Default Payment Method</title>
                                    <path class="stroke_layer fill_layer" fill="#082538" stroke="#082538" stroke-linecap="round"
                                          stroke-linejoin="round" stroke-width="4.6"
                                          d="M36.3 9l6.3 20.6h20.7L46.6 42.4 52.9 63 36.3 50.3 19.6 63l6.3-20.6L9.3 29.6h20.6L36.3 9z">
                                    </path>
                                </svg>
                            </span>
                            </div>
                            <div class="HOA-flextable-component__cell-wallet-column2 HOA-flextable-component__cell--pV12 HOA-flextable-component__cell-value HOA-flextable-component__lg-space-between">
                                <a [routerLink]="['/wallet/viewcheckdetails', check.id]" [state]="{paymentMethodId: check.id}" tid="checkDetailsLink">
                                    <div class="HOA-wallet-landing-bank-name" tid="checkingAcctPaymentMethodNickname">{{check.nickname}}
                                        <span class="HOA-wallet-landing-bank-number" tid="checkingAcctMaskedNumber">({{check.maskedId}})</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="HOA-container__content-hrule HOA-flextable-component__cell--100"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-page-content>`;
// Exports
module.exports = code;